import { render } from "./UpsertIntegrationOrderModal.vue?vue&type=template&id=0b29a5a3"
import script from "./UpsertIntegrationOrderModal.vue?vue&type=script&lang=js"
export * from "./UpsertIntegrationOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__